export function brandColorStyles() {
  return `
    .brand-active .btn.green {
      display: none;
    }

    .brand-active .landing-page-content .full-logo .cls-2 {
      fill: @brandThemeColor@;
    }

    .brand-active .logo .propertycapsule-small-logo-inner-content {
      fill: @brandThemeColor@;
    }

    .brand-active .header-right-section .user-area.active {
      background: @brandThemeColor@;
    }

    .brand-active .drop-down-container.profile-dropdown .drop-down-row.bottom-line .profile-img-container .user-initials {
      background-color: @brandThemeColor@;
    }

    .brand-active .header .header-button.active {
      background-color: @brandThemeColor@;
    }

    .brand-active .header .header-button.active .sub-header {
      background: @brandThemeColor@;
    }

    .brand-active .save-maps-dropdown .drop-down-row .register-btn {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .save-maps-dropdown .drop-down-row .cancel-btn {
      color: @brandThemeColor@ !important;
    }

    .brand-active .share-maps-dropdown .drop-down-row .email-btn {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .share-maps-dropdown .drop-down-row .cancel-btn {
      color: @brandThemeColor@ !important;
    }

    .brand-active .share-maps-dropdown .drop-down-row .link-btn {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .share-maps-dropdown .drop-down-row .embed-btn {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .password-reset-container .register-btn.log-in {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .password-reset-container .password-reset-content .close-btn:hover {
      color: @brandThemeColor@;
    }

    .brand-active .sign-in-container .sign-in-content .material-icons:hover {
       color: @brandThemeColor@;
    }

    .brand-active .sign-in-container .sign-in-content .sign-in-form .form-field-container .form-field .forgot-link {
      color: @brandThemeColor@;
    }

    .brand-active .sign-in-container .sign-in-content .sign-in-form .form-field-container .form-field .forgot-link:hover {
      color: @brandThemeColor@;
    }

    .brand-active .sign-in-container .register-btn.log-in {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .forgot-password-container .forgot-password-content .material-icons:hover {
      color: @brandThemeColor@;
    }

    .brand-active .forgot-password-container .register-btn.log-in {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .sign-up-container .sign-up-content .material-icons:hover {
      color: @brandThemeColor@;
    }

    .brand-active .sign-up-container .sign-up-terms-container .sign-up-terms .sign-in-link {
      color: @brandThemeColor@;
    }

    .brand-active .sign-up-container .sign-up-terms-container .register-btn {
      background-color: @brandThemeColor@;
      border: 1px solid @brandThemeColor@;
      opacity: 0.75;
    }

    .brand-active .terms-container .terms-content .material-icons:hover {
      color: @brandThemeColor@;
    }

    .brand-active  .mastermap-warning-popup-container .mastermap-warning-popup-content .mastermap-warning-popup-form .mastermap-warning-popup-message .message-highlight {
      color: @brandThemeColor@;
    }

    .brand-active .mastermap-warning-popup-container .mastermap-warning-popup-content .mastermap-warning-popup-form .mastermap-warning-popup-btn-continer .cancel-btn {
      color: @brandThemeColor@;
    }    

    .brand-active .loader-img.property-capsule-loader-img {
      fill: @brandThemeColor@;
    }

    .brand-active .btn.top-position {
      background: @brandThemeColor@;
      color: #ffffff;
    }

    .brand-active .my-stuff-dropdown .my-stuff-activity-container .map-details-container .map-contents-container .map-description {
      border-left: 3px solid @brandThemeColor@;
    }

    .brand-active .demo-report-container .report-btn-container .btn.report-btn {
      background-color: @brandThemeColor@
    }
  `;
};

export function brandLogoStyles() {
  return ``;
};

export function brandSpecificStyles(brand) {
  let styles;
  switch (brand) {
    case 'jll':
      styles = jllCustomStyles();
      break;

    default:
      styles = '';
      break;
  }
  return styles;
};


//Custom brand styles
function jllCustomStyles() {
  return `
  .brand-active .my-stuff-dropdown .my-stuff-activity-container .property-details-container .property-content .property-name-container .property-content-container .available-container {
    color: #F47722;
  }

  .brand-active .header-right-section .app-switcher {
    right: 110px;
  }

  .brand-active .header-right-section .app-switcher.app-switcher-for-logged-in {
    right: 80px;
  }

  .brand-active .user-options-container .user-options .mobile-application-dropdown.mobile-profile-dropdown-active {
    color: @brandThemeColor@;
  }

  .brand-active .user-options-container .user-options .mobile-application-dropdown.mobile-profile-dropdown-active .material-icons {
    color: @brandThemeColor@;
  }

  .brand-active .user-options-container .user-options .mobile-application-dropdown.mobile-profile-dropdown-active .material-icons {
    color: @brandThemeColor@;
  }
  .brand-active .print-wrapper .print-component .preview-step-1 .print-buttons-section .print-button.next {
    background-color: @brandThemeColor@;
  }
  .brand-active .print-wrapper .print-component .preview-step-2 .print-buttons-section .print-button.option-selected {
    background-color: @brandThemeColor@;
  }
  `;
}


// WEBPACK FOOTER //
// ./src/app/constants/BrandStylingConstants.ts